import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { teamReducer } from "../../../storage/reducers";

export default class CoinToss extends Fragment {
    constructor(settings) {
        super();
        this.settings = settings;

        this.requiredData = [
            {
                name: "settings",
                type: FragmentDataType.CoinToss,
                displayName: "Coin toss"
            }
        ];
    }

    // eslint-disable-next-line no-unused-vars
    summarize(summaryContext, stringifier) {
        let message = "";
        const { tossWinner, offenseTeam } = this.settings || {};
        if (tossWinner && offenseTeam) {
            const { homeTeam, awayTeam } = summaryContext;
            const { teamName: homeTeamName } = homeTeam || "HOME";
            const { teamName: awayTeamName } = awayTeam || "AWAY";

            const tossWinnerTeamName =
                homeTeam.id === tossWinner.id ? homeTeamName : awayTeamName;
            const offenseTeamName =
                homeTeam.id === offenseTeam.id ? homeTeamName : awayTeamName;

            message = `${tossWinnerTeamName} won toss. ${offenseTeamName} starts offensive`;
        }

        return new FragmentSummary(message, "Coin Toss:");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            settings: this.settings
                ? {
                      tossWinner: teamReducer(this.settings.tossWinner),
                      offenseTeam: teamReducer(this.settings.offenseTeam)
                  }
                : null
        };
    }
}
